import { BayLevelEnum, ForeAftEnum } from "open-vessel-definition";
import { EIGHTANDHALF_FEET_IN_MM, EIGHT_FEET_IN_MM } from "../consts";
import { createDictionary, pad3 } from "@tedivo/tedivo-pure-helpers";
export function extractContainersFromBayLevelSlots(bayLcgVcgTcgAndPairings) {
    const containers = new Map();
    const { unpairedBays, pairedBays } = bayLcgVcgTcgAndPairings.pairedBaysCalc;
    const blpsAbove = bayLcgVcgTcgAndPairings.bayLevelPositionsAbove;
    const blpsBelow = bayLcgVcgTcgAndPairings.bayLevelPositionsBelow;
    const blpsAboveBayDict = createDictionary(blpsAbove, (blp) => blp.isoBay);
    const blpsBelowBayDict = createDictionary(blpsBelow, (blp) => blp.isoBay);
    // Iterate over unpaired bays.
    unpairedBays.forEach((bay) => {
        [blpsAboveBayDict[bay.base], blpsBelowBayDict[bay.base]].filter(Boolean).forEach((blp) => {
            blp.cellsInfo.forEach((cellInfo) => {
                if (cellInfo.restricted || !cellInfo.maxSize || !cellInfo.sizes)
                    return;
                const maxSizeCgs = cellInfo.sizes.get(cellInfo.maxSize);
                if (!maxSizeCgs)
                    return;
                const posBay = cellInfo.maxSize < 40
                    ? blp.isoBay
                    : blp.pairedBay === ForeAftEnum.FWD
                        ? pad3(Number(blp.isoBay) - 1)
                        : pad3(Number(blp.isoBay) + 1); // By default, it is ForeAftEnum.AFT (even when it's not paired)
                const position = `${posBay}${cellInfo.row}${cellInfo.tier}`;
                containers.set(position, {
                    pk: position,
                    position,
                    size: maxSizeCgs.size,
                    height: EIGHTANDHALF_FEET_IN_MM,
                    width: EIGHT_FEET_IN_MM,
                    isReefer: cellInfo.isReefer,
                    isAbove: blp.level === BayLevelEnum.ABOVE ? 1 : 0,
                });
            });
        });
    });
    pairedBays.forEach((pBays) => {
        [
            blpsAboveBayDict[pBays.base],
            blpsAboveBayDict[pBays.paired],
            blpsBelowBayDict[pBays.base],
            blpsBelowBayDict[pBays.paired],
        ].filter(Boolean).forEach((blp) => {
            blp.cellsInfo.forEach((cellInfo) => {
                var _a;
                if (cellInfo.restricted || !cellInfo.maxSize || !cellInfo.sizes)
                    return;
                const maxSizeCgs = cellInfo.sizes.get(cellInfo.maxSize);
                if (!maxSizeCgs)
                    return;
                const pairedBay = blp.isoBay === pBays.base ? pBays.paired : pBays.base;
                const level = blp.level;
                const isLessThan40ft = cellInfo.maxSize < 40;
                // When it's a 20ft container, check if the pairedBay contains a 40ft container
                // If it does, then the 20ft container shouldn't be added
                if (isLessThan40ft) {
                    const pairedBlp = level === BayLevelEnum.ABOVE
                        ? blpsAboveBayDict[pairedBay]
                        : blpsBelowBayDict[pairedBay];
                    if ((_a = pairedBlp === null || pairedBlp === void 0 ? void 0 : pairedBlp.getCellInfo(`${cellInfo.row}${cellInfo.tier}`)) === null || _a === void 0 ? void 0 : _a.has40Size()) {
                        return;
                    }
                }
                const posBay = isLessThan40ft
                    ? blp.isoBay
                    : blp.pairedBay === ForeAftEnum.FWD
                        ? pad3(Number(blp.isoBay) - 1)
                        : pad3(Number(blp.isoBay) + 1); // By default, it is ForeAftEnum.AFT (even when it's not paired)
                const position = `${posBay}${cellInfo.row}${cellInfo.tier}`;
                containers.set(position, {
                    pk: position,
                    position,
                    size: maxSizeCgs.size,
                    height: EIGHTANDHALF_FEET_IN_MM,
                    width: EIGHT_FEET_IN_MM,
                    isReefer: cellInfo.isReefer,
                    isAbove: blp.level === BayLevelEnum.ABOVE ? 1 : 0,
                });
            });
        });
    });
    return Array.from(containers.values());
}
